import React, { useState } from 'react';
import { User } from '../../state/types';
import { useDispatch } from 'react-redux';
import addToBlocklistOrAllowlist from '../../state/actions/add-to-blocklist-or-allowlist';
import Checkbox from '../../../../common/inputs/checkbox-input';

interface Props {
  user: User;
  userId: string;
  ip: string;
  onClose: () => void;
}

export const AddToBlockListModal: React.FC<Props> = ({ user, userId, ip, onClose = () => {} }) => {
  const [isIp, setIsIp] = useState<boolean>(false);
  const [isUserId, setIsUserId] = useState<boolean>(false);
  const [isApplyHistory, setIsApplyHistory] = useState<boolean>(false);

  const dispatch = useDispatch();
  const addToBlocklist = props => dispatch(addToBlocklistOrAllowlist(props));

  const onAddClick = () => {
    let props = {
      type: 'BLOCKLIST',
      applyOnHistory: isApplyHistory,
      ...(isUserId && { userId, user }),
      ...(isIp && { ip })
    };

    addToBlocklist(props);
    onClose();
  };

  let username = null;
  if (user) {
    username = user.getUsername();
  } else {
    username = `Guest (${userId})`;
  }

  return (
    <div className="add-to-blacklist">
      <div className={'modal-title'}>Add to Blocklist</div>
      <div className="modal-description">
        Future comments from blocked entries will be automatically rejected. Please select which you
        would like to add:
      </div>
      {userId && (
        <Checkbox
          value={isUserId}
          text={'User: ' + username}
          className="blacklist-checkbox"
          onChange={() => setIsUserId(!isUserId)}
        />
      )}
      {ip && (
        <Checkbox
          value={isIp}
          text={'IP: ' + ip}
          className="blacklist-checkbox"
          onChange={() => setIsIp(!isIp)}
        />
      )}
      {(userId || ip) && (
        <Checkbox
          value={isApplyHistory}
          className="blacklist-checkbox"
          text="Apply to all previous comments"
          onChange={() => setIsApplyHistory(!isApplyHistory)}
        />
      )}
      <div className="black-list-footer">
        <button className="add-button" disabled={!(isUserId || isIp)} onClick={onAddClick}>
          Add to Blacklist
        </button>
      </div>
    </div>
  );
};
